export default {
  CalendarStrip__TAB_NEXT: "Next",
  CalendarStrip__TAB_PREVIOUS: "Previous",
};
